import { ChartDataPoint, FAQItem, GlossaryItem, MethodItem, Metric } from './types';

// Slogan & Branding
export const BRAND_NAME = "CarrionBET";
export const SLOGAN = "Análisis Profesional y Rentabilidad en Apuestas Deportivas.";

// Performance Metrics
export const KEY_METRICS: Metric[] = [
  { label: "Yield Verificado", value: "18.5%", subtext: "Auditado externamente", trend: 'up' },
  { label: "ROI Acumulado", value: "135.1%", subtext: "Últimos 4 meses", trend: 'up' },
  { label: "Win Rate", value: "62.4%", subtext: "Cuota Media @1.95", trend: 'neutral' },
  { label: "Beneficio Neto", value: "+135.1u", subtext: "Unidades ganadas", trend: 'up' },
];

// Chart Data
export const PERFORMANCE_DATA: ChartDataPoint[] = [
  { month: 'Oct', profit: 80.93, yield: 98.16 },
  { month: 'Nov', profit: 115.06, yield: 59.35 },
  { month: 'Dic', profit: 118.15, yield: 10.75 },
  { month: 'Ene', profit: 135.13, yield: 64.33 },
];

// Methodology Content
export const METHODOLOGY_ITEMS: MethodItem[] = [
  {
    title: "Análisis de Mercado",
    description: "Estudio exhaustivo de las líneas de apuestas en ligas principales, identificando discrepancias entre la realidad deportiva y las cuotas publicadas.",
    icon: "Activity"
  },
  {
    title: "Errores de Cuota",
    description: "Análisis a mano de las cuotas diferentes entre Betfair y Bet365 para caer en un error de cuota y sacarle partido.",
    icon: "TrendingUp"
  },
  {
    title: "Premium",
    description: "Aquí se sube todo antes que a Telegram y Twitter, por solo 15€ al mes puedes formar parte, aparte puedes disfrutar de muchas ventajas.",
    icon: "BarChart2"
  }
];

// Risk Management Content
export const RISK_MANAGEMENT_TEXT = {
  title: "Gestión del Bank",
  description: "La diferencia entre un apostador recreacional y uno que quiere ganar dinero es la gestión del Bank. El sistema que yo uso protege el bank a toda costa.",
  points: [
    "Estrategia de Stake plano (1/0.5/0.2) * dependiendo apuesta",
    "Disciplina férrea para no caer en un bucle tras varias apuestas perdidas",
    "Uso de escaleras para un mayor aumento de bank"
  ]
};

// Glossary
export const GLOSSARY_ITEMS: GlossaryItem[] = [
  { term: "1. Cuota (Odds)", definition: "Es el número que indica cuánto ganarás por tu apuesta. Ejemplo: Cuota 2.00 → Si apuestas $10, ganas $20." },
  { term: "2. Stake", definition: "Es la cantidad de dinero que apuestas. Ejemplo: Stake = $50 (es lo que arriesgas)." },
  { term: "3. Probabilidad implícita", definition: "Es la probabilidad que la casa asigna a un resultado según la cuota. Fórmula: 100 ÷ Cuota. Ejemplo: Cuota 2.00 = 50%." },
  { term: "4. Pick", definition: "Es el pronóstico o selección que haces. Ejemplo: Pick: “Gana Barcelona”." },
  { term: "5. Over / Under", definition: "Apuestas sobre si un valor será mayor o menor. Ejemplo: Over 2.5 goles → 3 o más goles." },
  { term: "6. Hándicap", definition: "Ventaja o desventaja ficticia para equilibrar equipos. Ejemplo: Real Madrid -1 (Debe ganar por 2 goles o más)." },
  { term: "7. Moneyline (Ganador)", definition: "Apuesta directa al ganador del partido. Ejemplo: Gana local / empate / gana visitante." },
  { term: "8. Parlay / Combinada", definition: "Varias apuestas en una sola. Todas deben acertarse para ganar. Ejemplo: 3 partidos combinados → si fallas uno, pierdes todo." },
  { term: "9. Cash Out", definition: "Opción para cerrar tu apuesta antes de que termine. Puede ser para asegurar ganancia parcial o minimizar pérdida." },
  { term: "10. Bankroll", definition: "Es tu dinero total destinado para apostar. Ejemplo: Bankroll = $500." },
  { term: "11. Yield", definition: "Mide tu rentabilidad sobre lo apostado. Ejemplo: Ganaste $50 con $100 apostados = 50%." },
  { term: "12. Void (Nula)", definition: "La apuesta se anula y te devuelven el dinero. Ejemplo: Jugador no juega → apuesta void." },
  { term: "13. Live / En vivo", definition: "Apuestas realizadas mientras el evento está ocurriendo en tiempo real." },
  { term: "14. Cuota fija / Variable", definition: "Fija: no cambia una vez apostada. Variable: fluctúa según el mercado (como en apuestas de intercambio)." },
  { term: "15. Value Bet", definition: "Apuesta con valor: Cuando crees que la cuota es mejor que la probabilidad real. Ejemplo: Probabilidad real 70%, cuota implica 50%." },
];

// FAQ
export const FAQ_ITEMS: FAQItem[] = [
  {
    question: "¿Qué tipo de mercados analizas?",
    answer: "Analizo remates, faltas recibidas, faltas cometidas y entradas de todas las ligas que haya disponible en Bet365 / Betfair / Pokerstars."
  },
  {
    question: "¿Por qué no ganas siempre?",
    answer: "No soy dios."
  },
  {
    question: "¿Es necesario tener mucho dinero para empezar?",
    answer: "No, con cualquier bank se gana dinero si sigues el stake que marco en las escaleras / picks que mando."
  },
  {
    question: "¿En qué casas de apuestas opero?",
    answer: "Bet365, Winamax, Betfair, Pokerstars y Kirolbet."
  },
  {
    question: "¿Con cuánta antelación se mandan los picks?",
    answer: "24 horas o menos siempre, de lo contrario es early y te podrían tirar la cuenta."
  }
];